import { FormlyFieldConfig } from '@ngx-formly/core';
import { advancedSection, COMMON_FIELD_CONFIGS } from './field-config-shared';

/**
 * number: type → label → required → [Advanced: width, min, max, step, prefillLastValue]
 */
export function getNumberFieldConfigFields(): FormlyFieldConfig[] {
  return [
    COMMON_FIELD_CONFIGS['type'],
    COMMON_FIELD_CONFIGS['label'],
    COMMON_FIELD_CONFIGS['required'],
    advancedSection(
      COMMON_FIELD_CONFIGS['width'],
      {
        key: 'min',
        type: 'number',
        props: {
          label: 'formBuilder.min',
          placeholder: 'formBuilder.minPlaceholder',
          description: 'formBuilder.minHelp',
        },
      },
      {
        key: 'max',
        type: 'number',
        props: {
          label: 'formBuilder.max',
          placeholder: 'formBuilder.maxPlaceholder',
          description: 'formBuilder.maxHelp',
        },
      },
      {
        key: 'step',
        type: 'number',
        props: {
          label: 'formBuilder.step',
          placeholder: 'formBuilder.stepPlaceholder',
          description: 'formBuilder.stepHelp',
          min: 0,
        },
      },
      COMMON_FIELD_CONFIGS['prefillLastValue'],
    ),
  ];
}
